import React, { memo } from 'react';

import { IconSize } from 'constants/coreDesignSystem';

import { sizePropsTypes } from './icons.constants';

const AiSparkleIcon = ({ size = IconSize[24], ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 2L14.09 8.26L20.35 10.35L14.09 12.44L12 18.7L9.91 12.44L3.65 10.35L9.91 8.26L12 2ZM18.5 14.5L19.54 17.46L22.5 18.5L19.54 19.54L18.5 22.5L17.46 19.54L14.5 18.5L17.46 17.46L18.5 14.5Z"
      fill="currentColor"
    />
  </svg>
);

AiSparkleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AiSparkleIcon);
